import React from "react";
import "./teamView.css";
import Heading from "../Heading";
import Modal from "../Modal";
import "animate.css/animate.min.css";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import { team_constants } from "../../constant/team_constants";
import { team_constants1 } from "../../constant/team_constants";
const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
      style={{ margin: "0% auto 0px" }}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div className="item_des">
            <div dangerouslySetInnerHTML={{ __html: activeItem.post }}></div>
          </div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

export class Partners extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeItem: {},
      isShow: false,
    };
  }
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { isShow } = this.state;
    return (
      <div className="section__content">
        <div className="team__wrapper">
          <div className="team__section">
            <div className="team_content">
              <div className="low__heading"></div>
              <div className="">
                <Heading title="Founder" />
              </div>

   <div className="team_member">
                <div className="row">
                  {team_constants1.map((item, i) => {
                    return (
                      <div className="tcard col-lg-3 col-md-4 col-sm-6" key={i}>
                        <div className="mem_card">
                          <div onClick={() => this.togglePopUp(item)}>
                            <div className="t_img">
                              <img src={item.imgUrl} alt={item.name} />
                            </div>
                            <div className="t_border"></div>
                            <div className="t_name">{item.name}</div>
                            <div className="t_post">
                              <div
                                dangerouslySetInnerHTML={{ __html: item.post }}
                              ></div>
                            </div>
                            <div className="social_link">
                              <a
                                rel="noopener noreferrer"
                                href={item.link}
                                target="_blank"
                                className=""
                              >
                                <i className="fa fa-linkedin"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
<br/><br/><br/>
<div className="">
                <Heading title="Advisors" />
              </div>


              <div className="team_member" style={{width:'65%'}}>
                <div className="row">
                  {team_constants.map((item, i) => {
                    return (
                      <div className="tcard col-lg-4 col-md-4 col-sm-6" key={i}>
                        <div className="mem_card">
                          <div onClick={() => this.togglePopUp(item)}>
                            <div className="t_img">
                              <img src={item.imgUrl} alt={item.name} />
                            </div>
                            <div className="t_border"></div>
                            <div className="t_name">{item.name}</div>
                            <div className="t_post">
                              <div
                                dangerouslySetInnerHTML={{ __html: item.post }}
                              ></div>
                            </div>
                            <div className="social_link">
                              <a
                                rel="noopener noreferrer"
                                href={item.link}
                                target="_blank"
                                className=""
                              >
                                <i className="fa fa-linkedin"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
         
         
                <div className="volunteer_section">
                <div className="volunteer_text">
                  <div className="col-md-3">&nbsp;</div>
                
<div className="col-md-3">
                   <div className="volunteer_link"  style={{width:'100%'}}>
                    <Link to="/team/">Winpe Team</Link>
                  </div>
                  </div>
                    <div className="col-md-3">
                  <div className="volunteer_link" style={{width:'100%'}}>
                    <Link to="/ambassadors/">Winpe Ambassadors</Link>
                  </div>
</div>
                </div>
                
                </div> 
  <br/><br/>
            </div>
          </div>
          <TeamModal
            show={isShow}
            onHide={this.togglePopUp}
            activeItem={this.state.activeItem}
          />
          <div className="section_divider1">
            <img
              src="https://winpeforum.com/assets/elements/Section_divier_gray.png"
              width="100%"
              alt="section_divider"
              className="img-responsive"
            />
          </div>
          <div className="section_divider">
            <img
              src="https://winpeforum.com/assets/elements/phone_section_divider.png"
              width="100%"
              alt="section_divider"
              className="img-responsive"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Partners;



// WEBPACK FOOTER //
// ./src/components/team/index.js